import styled from '@emotion/styled'

import { useTheme } from '@emotion/react'

import { useMemo } from 'react'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import Navigation from '@segment/templates/Navigation'
import GettingStarted from '@segment/templates/GettingStarted'
import LogoCarousel from '@segment/templates/LogoCarousel'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'
import RelatedContent from './components/RelatedContent'
import CreateHighlyPersonalizedExperiences from './components/CreateHighlyPersonalizedExperiences'
import SyncData from './components/SyncData'
import Connected from './components/Connected'

import ogImagePng from './assets/OgReverseEtl.png'

const ReverseEtlView = () => {
  const theme = useTheme()

  const layoutData = useMemo(
    () => ({
      title: `Reverse ETL | Twilio Segment`,
      description: `Reverse ETL enables you to activate data from your data warehouse across any supported Segmented destination. No need to onboard a new tool. Come find out what Twilio Segment can do for you.`,
      og: ogImagePng,
      backgroundColor: theme.palette.neutrals.white[100],
    }),
    [theme]
  )

  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle={layoutData.title}
        pageDescription={layoutData.description}
        pageOG={layoutData.og}
        bodyBackground={layoutData.backgroundColor}
      >
        <Navigation />
        <Hero />
        <Main>
          <StyledLogoCarousel />
          <CreateHighlyPersonalizedExperiences />
          <SyncData />
          <Connected />
          <RelatedContent />
          <GettingStarted />
        </Main>
        <Footer />
      </Layout>
    </AppearanceProvider>
  )
}

const StyledLogoCarousel = styled(LogoCarousel)`
  ${({ theme }) => theme.breakpoints.up(`md`)} {
    padding-top: 64px;
    padding-bottom: 60px;
  }
`

const Main = styled.main`
  overflow-x: hidden;
  background-color: ${({ theme }) => theme.palette.neutrals.white[100]};
`

export default ReverseEtlView
